import React, { useState } from "react";
import { useLoginMutation } from "../../features/auth/authAPI";

function LoginForm() {
  const [formData, setFormData] = useState({});
  const [login, { isLoading, isError }] = useLoginMutation();
  function handleChange(event) {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  }

  function handleSubmit(event) {
    event.preventDefault();
    login(formData);
  }

  return (
    <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
      {/* <input type="hidden" name="remember" value="true" /> */}

      {isError && (
        <div
          class="bg-red-100 border border-red-400  px-4 py-3 rounded relative"
          role="alert"
        >
          <strong class="font-bold text-red-700">Error!</strong>
          <span class="block sm:inline text-red-700">
            Login Failed. Please try again!
          </span>
        </div>
      )}
      <div className="rounded-md shadow-sm -space-y-px">
        <div>
          <label htmlFor="email-address" className="sr-only">
            Email address
          </label>
          <input
            id="email-address"
            name="email"
            type="email"
            autoComplete="email"
            required
            className="login-input rounded-t-md"
            placeholder="Email address"
            onChange={handleChange}
          />
        </div>
        <div>
          <label htmlFor="password" className="sr-only">
            Password
          </label>
          <input
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
            required
            className="login-input rounded-b-md"
            placeholder="Password"
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="flex items-center justify-end ">
        <div className="text-sm">
          <span className="font-medium text-violet-600 hover:text-violet-500">
            Forgot your password?
          </span>
        </div>
      </div>

      <div>
        <button
          type="submit"
          className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
          disabled={isLoading}
        >
          Sign in
        </button>
      </div>
    </form>
  );
}

export default LoginForm;
